// import BannerDesktop from '../../assets/images/small_banner_desktop.jpeg';
// import BannerMobile from '../../assets/images/small_banner_mobile.jpeg';

// Promotional partner banner shown above the main nav on every page. Rendered inside
// `MainHeader` (navbar.tsx) so it appears everywhere that component is used, without
// touching every individual page.
//
// The two SVG assets (from assets/images) already carry everything — background gradient,
// partner emblem, divider, VouchLinks badge icon, AND both text strings (baked in as
// outlined/rasterized art, not <text> elements, which is why a first pass here mistakenly
// overlaid duplicate HTML text on top of it). Just render the images; no overlay needed.
// Heights match the assets' native size exactly (70px desktop / 52px mobile), which is what
// the consuming layouts reserve space for.
//
// Disabled — promo campaign ended, banner no longer needed. Kept commented out (rather than
// deleted) in case a future campaign reuses this same slot.
export const TopBanner: React.FC = () => null;
// (
//   <>
//     <img
//       src={BannerDesktop}
//       alt="Official Recommendation Partner for Itsekiri Global Homecoming 2026 — Earn 2x rewards on VouchLinks from 16th - 22nd August, 2026"
//       className="hidden md:block w-full object-cover"
//     />
//     <img
//       src={BannerMobile}
//       alt="Official Recommendation Partner for Itsekiri Global Homecoming 2026 — Earn 2x rewards on VouchLinks from 16th - 22nd August, 2026"
//       className="md:hidden w-full h-[52px] object-cover"
//     />
//   </>
// );
